module.exports = __webpack_public_path__ + "img/part6-icon2-over.e7421330.png";